import styles from './ContactList.module.css';
import { useEffect } from 'react';
import resultsBoxStyles from '../ResultsBox.module.css';
// import { capitalize } from 'functions/fields';
import { getUrl } from 'functions/getUrl';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { tryFetchWithAuth } from 'utils/fetchWithAuth';
import { useCredits } from 'contexts/CreditsContext';

const CREDIT_COSTS = { email: 1, mobile: 5 };

const ContactList = ({ 
  results,
  contacts, 
  selectedContacts, 
  onSelectOne 
}) => {
    const [hoveredEmailId, setHoveredEmailId] = useState(null);
    const [hoveredMobilePhoneId, setHoveredMobilePhoneId] = useState(null);
    const [hoveredCompanyPhoneId, setHoveredCompanyPhoneId] = useState(null);
    // After a successful unlock we merge the server response here so the row
    // reflects the revealed value + unlocked state without re-fetching search.
    const [unlockOverrides, setUnlockOverrides] = useState({});
    const [unlockBusy, setUnlockBusy] = useState({}); // {contactId_field: true}
    const [unlockError, setUnlockError] = useState({}); // {contactId_field: msg}

    const { applyDelta, refresh: refreshCredits } = useCredits();
    const history = useHistory();

    const handleCheckboxChange = (contactId) => {
      onSelectOne(contactId);
    }

    const getDisplayContact = (contact) => {
        const overrides = unlockOverrides[contact.contact_id];
        if (!overrides) return contact;
        return { ...contact, ...overrides };
    };

    const handleUnlock = async (e, contactId, field) => {
        e.stopPropagation();
        e.preventDefault();
        const key = `${contactId}_${field}`;
        if (unlockBusy[key]) return;
        setUnlockBusy(prev => ({ ...prev, [key]: true }));
        setUnlockError(prev => ({ ...prev, [key]: null }));

        const { data, error, status } = await tryFetchWithAuth('/unlock', {
            method: 'POST',
            body: JSON.stringify({ contactId, field }),
        });

        setUnlockBusy(prev => ({ ...prev, [key]: false }));

        if (status === 402) {
            setUnlockError(prev => ({ ...prev, [key]: 'Not enough credits' }));
            history.push('/upgrade');
            return;
        }
        if (error || !data) {
            setUnlockError(prev => ({ ...prev, [key]: typeof error === 'string' ? error : 'Unlock failed' }));
            return;
        }

        setUnlockOverrides(prev => ({
            ...prev,
            [contactId]: {
                ...(prev[contactId] || {}),
                ...(field === 'email'
                    ? { email: data.email, email_unlocked: true }
                    : {
                        mobile_phone: data.mobile_phone,
                        direct_phone: data.direct_phone,
                        direct_phone_type: data.direct_phone_type,
                        mobile_unlocked: true,
                    }),
            },
        }));

        if (typeof data.creditsBalance === 'number') {
            // Server is source of truth; pull fresh balance rather than guessing delta.
            refreshCredits();
        } else {
            applyDelta(-CREDIT_COSTS[field]);
        }
    };

    useEffect(() => {
        console.log(selectedContacts.length, "selected contacts:", selectedContacts);
    }, [selectedContacts]);
  
    return ( 
<div className={styles.contactListContainer}>
<div className={styles.contactList}>
	{contacts.length > 0 ? (<table>
		<thead>
			<tr>
				<th>Name</th>
				<th>Title</th>
				<th>Company</th>
				<th>Email</th>
				<th>Mobile Phone</th>
				<th>Company Phone</th>
				<th>Company Links</th>
				<th>Contact Location</th>
				{/* <th>Industry</th>
				<th>Company Headcount</th> */}
				{/* <th>Company Revenue</th>
				<th>Company Funding</th>
				<th>Retail Locations</th>
				<th>Year Founded</th> */}
				<th>Company Location</th>
			</tr>
		</thead>
		{contacts.map(contact => {
			const dc = getDisplayContact(contact);
			const emailLocked = !dc.email_unlocked;
			const mobileLocked = !dc.mobile_unlocked;
			const emailUnlockKey = `${contact.contact_id}_email`;
			const mobileUnlockKey = `${contact.contact_id}_mobile`;
			return (
		<tbody key={contact.contact_id}>
			<tr>
			<td>
				<div className={`${styles.tdContent} ${styles.contactName}`}>
				<span>
					<input
					type="checkbox"
					checked={selectedContacts.includes(contact.contact_id)}
					onChange={() => handleCheckboxChange(contact.contact_id)}
					className={resultsBoxStyles.searchCheckbox}
					disabled={results?.saved === false && contact?.saved === true}
					/>
				</span>
				<span className={styles.contactNameText} onClick={() => {handleCheckboxChange(contact.contact_id)}}>
					<u>{contact.first_name} {contact.last_name}</u>
				</span>
				{contact.contact_linkedin_url === true && (
					<div className={`${styles.urlBubble} ${styles.contactLinkedInBubble}`} onClick={() => {getUrl({id: contact.contact_id, type: 'contact',urlType: 'linkedin_url'})}}>
						<svg width="1.25rem" height="1.25rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>
					</div>
				)}
				</div>
			</td>
			<td>
				<div className={styles.tdContent}>
				{contact.title}
				</div>
			</td>
			<td>
				<div className={styles.tdContent} onClick={() => {getUrl({id: contact.company_id, type: 'company',urlType: 'website_url'})}}>
				{contact.company_logo_url ? (
					<img
					src={contact.company_logo_url}
					alt="Company Logo"
					className={styles.companyLogo}
					/>
				) :
				(
					<img
					src="/DefaultCompanyLogo.jpeg"
					alt="Company Logo"
					className={styles.companyLogo}
					/>
				)}
				{contact.company_name}
				</div>
			</td>

			{/* EMAIL */}

			<td>
				{contact?.saved === false && hoveredEmailId === contact.contact_id && (
					<div className={styles.emailTooltip}>
						{contact.email_status === 'valid' ? 'Email is valid. Save this contact to reveal.' :
						contact.email_status === 'catch all' ? 'Email is a catch all. Save this contact to reveal.' :
						(!contact.email || !contact.email_status) ? 'No email found. Searching for new email...' :
						contact.email_status === 'invalid' ? 'Email is invalid. Searching for new email...' :
						 'Email status unknown.'}
					</div>
				)}
				<div className={styles.tdContent}>
				{
					<div className={styles.validEmailContainer} 
					onMouseEnter={() => setHoveredEmailId(contact.contact_id)}
					onMouseLeave={() => setHoveredEmailId(null)}
					onClick={() => {handleCheckboxChange(contact.contact_id)}}
					>
					{/* <span  
					// className={
					// 	contact.email_status === 'valid' ? styles.greenDot : 
					// 	contact.email_status === 'catch all' ? styles.yellowDot : 
					// 	contact.email_status === 'invalid' ? styles.redDot : 
					// 	styles.blackDot 
					// }
					></span> */}
						{/* <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#02C797" class="no-cascade"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" class="no-cascade"></path></g><defs><clipPath id="email-verified-clip"><path fill="#fff" d="M0 0h18v18H0z"></path></clipPath></defs></svg> */}
						<span className={styles.infoStatusContainer}>
							{contact.email_status === 'valid' ? (
								<svg className={styles.infoStatusIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g>
										<path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path>
										
										{/* Note the camelCase fillRule and clipRule here */}
										<path fillRule="evenodd" clipRule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#02C797" className="no-cascade"></path>
										
										{/* Note the camelCase and className here */}
										<path fillRule="evenodd" clipRule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" className="no-cascade"></path>
									</g>
									<defs>
										<clipPath id="email-verified-clip">
											<path fill="#fff" d="M0 0h18v18H0z"></path>
										</clipPath>
									</defs>
								</svg>
							):
							contact.email_status === 'catch all' ? (
								<svg className={styles.infoStatusIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g>
									<path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path>
									
									{/* Note the camelCase fillRule and clipRule here */}
									<path fillRule="evenodd" clipRule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#FFC107" className="no-cascade"></path>
									
									{/* Note the camelCase and className here */}
									<path fillRule="evenodd" clipRule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" className="no-cascade"></path>
								</g>
								<defs>
									<clipPath id="email-verified-clip">
										<path fill="#fff" d="M0 0h18v18H0z"></path>
									</clipPath>
								</defs>
							</svg>
							) :
							contact.email_status === 'invalid' ? (<div style={{
								display: 'flex',
								justifyContent: 'start',
								alignItems: 'center',
								gap: '8px',
								fontFamily: "'Inter', sans-serif",
								fontWeight: 500,
								fontSize: '14px',
								// color: contact.email_status === 'valid' ? '#02C797' : contact.email_status === 'catch all' ? '#FFC107' : contact.email_status === 'invalid' ? '#D32F2F' : '#6b7f9d'
							}}>
								<div className={styles.spinnerRed}></div> 
							</div>) :
							(contact.email_status === 'unknown' || (contact.email && (!contact.email_status || contact.email_status !== 'valid' || contact.email_status !== 'catch all' || contact.email_status !== 'invalid' || contact.email_status !== 'unknown'))) ? (
								<svg className={styles.infoStatusIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g>
										<path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path>
										
										{/* Changed fill to #9E9E9E for a neutral grey */}
										<path fillRule="evenodd" clipRule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#9E9E9E" className="no-cascade"></path>
										
										{/* Note the camelCase and className here */}
										<path fillRule="evenodd" clipRule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" className="no-cascade"></path>
									</g>
									<defs>
										<clipPath id="email-verified-clip">
											<path fill="#fff" d="M0 0h18v18H0z"></path>
										</clipPath>
									</defs>
								</svg>
							)
							: (<div style={{
								display: 'flex',
								justifyContent: 'start',
								alignItems: 'center',
								gap: '8px',
								fontFamily: "'Inter', sans-serif",
								fontWeight: 500,
								fontSize: '14px',
								// color: contact.email_status === 'valid' ? '#02C797' : contact.email_status === 'catch all' ? '#FFC107' : contact.email_status === 'invalid' ? '#D32F2F' : '#6b7f9d'
							}}>
								<div className={styles.spinnerGrey}></div> 
							</div>)}
					
							
						</span>
						{/* <span className={styles.infoText} style={{color:"#6b7f9d"}}>{contact.email ? contact.email : 'No email found'}</span> */}
						{dc.email ? (
							emailLocked ? (
								<span className={styles.unlockInline}>
									<span className={styles.infoText} style={{color:"#6b7f9d"}}>{dc.email}</span>
									<button
										type="button"
										className={styles.unlockButton}
										disabled={!!unlockBusy[emailUnlockKey]}
										onClick={(e) => handleUnlock(e, contact.contact_id, 'email')}
										title="Unlock email"
									>
										{unlockBusy[emailUnlockKey] ? 'Unlocking…' : `Unlock · ${CREDIT_COSTS.email} cr`}
									</button>
									{unlockError[emailUnlockKey] && (
										<span className={styles.unlockErrorText}>{unlockError[emailUnlockKey]}</span>
									)}
								</span>
							) : (
								<span className={styles.infoText}>{dc.email}</span>
							)
						) : (
							<span className={styles.infoText} style={{color:"#6b7f9d"}}>No email. Searching...</span>
						)}
					</div>
				}
				</div>
			</td>

			{/* MOBILE PHONE */}

			<td>
				{contact?.saved === false && hoveredMobilePhoneId === contact.contact_id && (
					<div className={styles.emailTooltip}>
						{contact.mobile_phone && 'Valid mobile phone. Save this contact to reveal.'}
						{!contact.mobile_phone && 'No mobile found. Searching for new mobile...'}
					</div>
				)}
				<div className={styles.tdContent}>
				{
					<div className={styles.validEmailContainer} 
					onMouseEnter={() => setHoveredMobilePhoneId(contact.contact_id)}
					onMouseLeave={() => setHoveredMobilePhoneId(null)}
					onClick={() => {handleCheckboxChange(contact.contact_id)}}
					>
					<span className={styles.infoStatusContainer}>
						{contact.mobile_phone && (
							<svg className={styles.infoStatusIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g>
									<path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path>
									
									{/* Note the camelCase fillRule and clipRule here */}
									<path fillRule="evenodd" clipRule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#02C797" className="no-cascade"></path>
									
									{/* Note the camelCase and className here */}
									<path fillRule="evenodd" clipRule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" className="no-cascade"></path>
								</g>
								<defs>
									<clipPath id="email-verified-clip">
										<path fill="#fff" d="M0 0h18v18H0z"></path>
									</clipPath>
								</defs>
							</svg>
						)}
						{(!contact.mobile_phone) && (<div style={{
								display: 'flex',
								justifyContent: 'start',
								alignItems: 'center',
								gap: '8px',
								fontFamily: "'Inter', sans-serif",
								fontWeight: 500,
								fontSize: '14px',
								// color: contact.email_status === 'valid' ? '#02C797' : contact.email_status === 'catch all' ? '#FFC107' : contact.email_status === 'invalid' ? '#D32F2F' : '#6b7f9d'
							}}>
								<div className={styles.spinnerGrey}></div> 
							</div>)}
						
					</span>
					{(dc.mobile_phone || dc.direct_phone) ? (
						mobileLocked ? (
							<span className={styles.unlockInline}>
								<span className={styles.infoText} style={{color:"#6b7f9d"}}>{dc.mobile_phone || dc.direct_phone}</span>
								<button
									type="button"
									className={styles.unlockButton}
									disabled={!!unlockBusy[mobileUnlockKey]}
									onClick={(e) => handleUnlock(e, contact.contact_id, 'mobile')}
									title="Unlock mobile"
								>
									{unlockBusy[mobileUnlockKey] ? 'Unlocking…' : `Unlock · ${CREDIT_COSTS.mobile} cr`}
								</button>
								{unlockError[mobileUnlockKey] && (
									<span className={styles.unlockErrorText}>{unlockError[mobileUnlockKey]}</span>
								)}
							</span>
						) : (
							<span className={styles.infoText}>{dc.mobile_phone || dc.direct_phone}</span>
						)
					) : (
						<span className={styles.infoText} style={{color:"#6b7f9d"}}>No mobile. Searching...</span>
					)}
					</div>
				}
				</div>
			</td>

			{/* COMPANY PHONE */}

			<td>
				{contact?.saved === false && hoveredCompanyPhoneId === contact.contact_id && (
					<div className={styles.emailTooltip}>
					Save this contact to reveal info
					</div>
				)}
				<div className={styles.tdContent}>
				{
					<>
					<div className={styles.validEmailContainer}
					onMouseEnter={() => setHoveredCompanyPhoneId(contact.contact_id)}
					onMouseLeave={() => setHoveredCompanyPhoneId(null)}
					onClick={() => {handleCheckboxChange(contact.contact_id)}}
					>
					</div>
					<span className={styles.infoStatusContainer}>
					{contact.company_phone && (
						<svg className={styles.infoStatusIcon} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g>
								<path d="M12.1 5.246H2.903a1.97 1.97 0 0 0-1.97 1.971v6.57a1.97 1.97 0 0 0 1.97 1.97H12.1a1.97 1.97 0 0 0 1.971-1.97v-6.57a1.97 1.97 0 0 0-1.97-1.97Zm-.269 1.314-3.863 3.863a.656.656 0 0 1-.933 0L3.172 6.56h8.659Zm.926 7.227a.657.657 0 0 1-.657.656H2.903a.657.657 0 0 1-.657-.656v-6.3l3.863 3.862a1.97 1.97 0 0 0 2.785 0l3.863-3.863v6.3Z" fill="#5D6A7E"></path>
								
								{/* Note the camelCase fillRule and clipRule here */}
								<path fillRule="evenodd" clipRule="evenodd" d="M7 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" fill="#02C797" className="no-cascade"></path>
								
								{/* Note the camelCase and className here */}
								<path fillRule="evenodd" clipRule="evenodd" d="M15.196 3.04a.8.8 0 0 1 .17 1.12L12.9 7.517a1.067 1.067 0 0 1-1.67.062L9.672 5.761a.8.8 0 1 1 1.215-1.04l1.121 1.308 2.07-2.817a.8.8 0 0 1 1.119-.171Z" fill="#fff" className="no-cascade"></path>
							</g>
							<defs>
								<clipPath id="email-verified-clip">
									<path fill="#fff" d="M0 0h18v18H0z"></path>
								</clipPath>
							</defs>
						</svg>
					)}
					{(!contact.company_phone) && (<div style={{
							display: 'flex',
							justifyContent: 'start',
							alignItems: 'center',
							gap: '8px',
							fontFamily: "'Inter', sans-serif",
							fontWeight: 500,
							fontSize: '14px',
							// color: contact.email_status === 'valid' ? '#02C797' : contact.email_status === 'catch all' ? '#FFC107' : contact.email_status === 'invalid' ? '#D32F2F' : '#6b7f9d'
						}}>
							<div className={styles.spinnerGrey}></div> 
						</div>)}
					
				</span>
				{contact.company_phone ? <span className={styles.infoText}>{contact.company_phone}</span> : <span className={styles.infoText} style={{color:"#6b7f9d"}}>No phone. Searching...</span>}
					</>
				}
				</div>
			</td>
			{/* COMPANY LINKS */}

			<td>
				<div className={styles.tdContent}>
				{contact.company_website_url ? (
					<div className={styles.urlBubble} onClick={() => {getUrl({id: contact.company_id, type: 'company',urlType: 'website_url'})}}>
					<svg width="1.25rem" height="1.25rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/></svg>
					</div>
				) : ''}
				{contact.company_linkedin_url ? (
					<div className={styles.urlBubble} onClick={() => {getUrl({id: contact.company_id, type: 'company',urlType: 'linkedin_url'})}}>
					<svg width="1.25rem" height="1.25rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>
					</div>
				) : ''}
				{contact.company_facebook_url ? (
					<div className={styles.urlBubble} onClick={() => {getUrl({id: contact.company_id, type: 'company',urlType: 'facebook_url'})}}>
					<svg width="1.25rem" height="1.25rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg> 
					</div>
				) : ''}
				{contact.company_twitter_url ? (
					<div className={styles.urlBubble} onClick={() => {getUrl({id: contact.company_id, type: 'company',urlType: 'twitter_url'})}}>
					<svg width="1.25rem" height="1.25rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
					</div>
				) : ''}
				</div>
			</td>

			{/* CONTACT LOCATION */}

			<td>
				<div className={styles.tdContent}>
				{contact.city ? `${contact.city}, ` : ""}
				{contact.state ? `${contact.state}, ` : ""}
				{contact.country ? `${contact.country}` : ""}
				</div>
			</td>

			{/* COMPANY INDUSTRY */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_industry && capitalize(contact.company_industry)}
				</div>
			</td> */}

			{/* COMPANY HEADCOUNT */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_headcount ? `${contact.company_headcount}` : ""}
				</div>
			</td> */}

			{/* COMPANY REVENUE */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_revenue ? `${contact.company_revenue}` : ""}
				</div>
			</td> */}

			{/* COMPANY FUNDING */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_funding ? `${contact.company_funding}` : ""}
				</div>
			</td> */}

			{/* RETAIL LOCATIONS */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_number_of_retail_locations ? `${contact.company_number_of_retail_locations}` : ""}
				</div>
			</td> */}

			{/* YEAR FOUNDED */}

			{/* <td>
				<div className={styles.tdContent}>
				{contact.company_founded_year ? `${contact.company_founded_year}` : ""}
				</div>
			</td> */}


			{/* COMPANY LOCATION */}

			<td>
				<div className={styles.tdContent}>
				{contact.company_city ? `${contact.company_city}, ` : ""}
				{contact.company_state ? `${contact.company_state}, ` : ""}
				{contact.company_country ? `${contact.company_country}` : ""}
				</div>
			</td>
			
			</tr>
		</tbody>
			);
		})}

	</table>
) : (
	<p>No contacts found for the given search.</p>
	)}
</div>    
</div>  
      );
  }
 
export default ContactList;